import * as type from '../../types/trans';


let init = {
    bankDetails: {},
    amount: 0,
    transDet: {},
    paymentRes: {},
}



export default function paymentCart(state = init, action) {
    switch (action.type) {

        case type.BANK_DETAILS:
            return {
                ...state,
                bankDetails: action.payload
            }

        case type.LUMSUM_AMT:
            return {
                ...state,
                amount: action.payload
            }

        case type.SAVE_TRANS:
            return {
                ...state,
                transDet: action.payload
            }

        case type.PAYMENT_RES:
            return {
                ...state,
                paymentRes: action.payload
            }
        default:
            return state
    }
}